import { render, staticRenderFns } from "./AdditionalServicePriceDetail.vue?vue&type=template&id=5b3b015d&scoped=true&"
import script from "./AdditionalServicePriceDetail.vue?vue&type=script&lang=js&"
export * from "./AdditionalServicePriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServicePriceDetail.vue?vue&type=style&index=0&id=5b3b015d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b015d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3b015d')) {
      api.createRecord('5b3b015d', component.options)
    } else {
      api.reload('5b3b015d', component.options)
    }
    module.hot.accept("./AdditionalServicePriceDetail.vue?vue&type=template&id=5b3b015d&scoped=true&", function () {
      api.rerender('5b3b015d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/price/AdditionalServicePriceDetail.vue"
export default component.exports